<template>
    <v-col class="py-0 pt-2">
        <v-row>
            <v-col cols="12" class="d-flex justify-center py-0" v-if="recipientInfo.name">
                <p class="title text-uppercase flex-grow-0 mb-0 font-weight-bold">{{ recipientInfo.name }}</p>
            </v-col>
            <v-col class="d-flex py-0">
                <v-icon class="mr-2">mdi-email</v-icon>
                <p class="subtitle-1 flex-grow-0 mb-0 font-weight-bold d-inline-block text-truncate ellipsis email green--text text--darken-1">
                    {{ recipientInfo.email }}
                </p>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon
                            color="primary"
                            dark
                            v-bind="attrs"
                            v-on="on"
                            size="16"
                        >
                            mdi-information-outline
                        </v-icon>
                    </template>
                    <span>{{ recipientInfo.email }}</span>
                </v-tooltip>
            </v-col>
            <v-col class="py-0">
                <v-btn
                    @click="copyToClipboard(recipientInfo.email)"
                    absolute
                    x-small
                    class="warning copy-button mt-1"
                >
                    Copy
                </v-btn>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
    export default {
        name: "match-confirmed-reveal-nigerian-zelle-payment",
        props: {
            recipientInfo: Object
        },
    }
</script>

<style scoped>
.ellipsis {
    max-width: 70%;
}
</style>
